module.exports = __webpack_public_path__ + "img/plaster-mortar.f5276ca9.jpg";